import { PickerOption } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';

/**
 * Get the next selectable option from the list of options after the specified index
 * @param index
 */
export default function getNextSelectableOption(
    viewState: CompositePickerStore,
    index: number
): PickerOption {
    const { filteredOptions } = viewState;
    let firstSelectableOptionBefore = null;
    let nextSelectableOption = null;

    for (let option of filteredOptions) {
        for (let leafOption of option.leafOptions) {
            if (leafOption.index > index && leafOption.isShown && !nextSelectableOption) {
                nextSelectableOption = leafOption;
            }

            if (leafOption.index < index && leafOption.isShown && !firstSelectableOptionBefore) {
                firstSelectableOptionBefore = leafOption;
            }
        }

        if (option.parentOptions) {
            for (let parent of option.parentOptions) {
                if (parent.index > index && parent.isShown && !nextSelectableOption) {
                    nextSelectableOption = parent;
                }
                if (parent.index < index && parent.isShown && !firstSelectableOptionBefore) {
                    firstSelectableOptionBefore = parent;
                }

                for (let child of parent.children) {
                    if (child.index > index && child.isShown && !nextSelectableOption) {
                        nextSelectableOption = child;
                    }

                    if (child.index < index && child.isShown && !firstSelectableOptionBefore) {
                        firstSelectableOptionBefore = child;
                    }
                }
            }
        }
    }

    return nextSelectableOption ? nextSelectableOption : firstSelectableOptionBefore;
}
